import { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
// import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import LogoutIcon from '@mui/icons-material/Logout';
import { useNavigate } from 'react-router-dom';
import axios from '../../../functions/requestInterceptor'
import { useTranslation } from 'react-i18next';
// import MenuItem from '@mui/material/MenuItem';
// import Select from '@mui/material/Select';
// import LanguageIcon from '@mui/icons-material/Language';
import Accordion from '@mui/material/Accordion';
import AccordionActions from '@mui/material/AccordionActions';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { InputWrapper } from './style';
import profileSchema from '../../../validation/editProfile'
import validate from '../../../validation/index'
import { toast } from 'react-toastify';

export default function LogoutDrawer(props) {
  const { t } = useTranslation('translation', { keyPrefix: 'dashboard' });

  const user = JSON.parse(localStorage.getItem('user'))
  const navigate = useNavigate()

  const [open, setOpen] = useState(props.open);

  useEffect(() => {
    setOpen(props.open)
  }, [props.open])

  const toggleDrawer = () => () => {
    props.handleClose();
  };

  const logout = () => {
    axios.post('/logout/')
     .then((response) => {
       navigate('/login')
     })
     .catch((error) => {
        console.log(error)
     })
  };

  const [data, setData] = useState({
    first_name: user.first_name,
    last_name: user.last_name,
    gender: user.gender
  })

  const [error, setError] = useState({})

  const validationData = () => {
    const params = data
    const constrains = profileSchema()

    const hasError = false
    let err = {}
    const keys = Object.keys(params)
    for (let i = 0; i < keys.length; i++) {
      const errorMessage = validate(params, keys[i], constrains)
      err = { ...err, [keys[i]]: errorMessage }
      if (errorMessage) {
        setError({ ...err })
        return true
      }
    }
    setError({ ...err })
    return hasError
  }

  const editProfileRequest = () => {
    axios.put('/profile/', data)
     .then((response) => {
       localStorage.setItem('user',JSON.stringify({...user, ...response.data}))
     })
     .catch((error) => {
      toast.error(error?.response?.data?.detail, {
        position: "top-right"
      });
     })
  };

  function handleClick () {
    const hasError = validationData()
    if (!hasError) {
      // empty error object
      setError({})
      // submit data
      editProfileRequest()
    }
  }

  const cancelEditProfile = () => {
    setData({
      first_name: user.first_name,
      last_name: user.last_name,
    })
  }

  const handleChangeProfile = (e) => {
    console.log(e.target.value)
    setData({...data, [e.target.name]: e.target.value})
  }

  // const handleChangeLang = (event) => {
  //   i18n.changeLanguage(event.target.value)
  // };
  const DrawerList = (
    <Box sx={{ width: 250 }} role="presentation">
      <List>
        <ListItem disablePadding>
          <ListItemButton>
            <ListItemIcon>
              <AccountCircleIcon />
            </ListItemIcon>
            <ListItemText primary={`${user?.first_name} ${user?.last_name}`} />
          </ListItemButton>
        </ListItem>
      </List>

      <List>
          <Accordion dir='rtl'>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
            >
              ویرایش پروفایل
            </AccordionSummary>
            <AccordionDetails>

              <InputWrapper>
                <span style={{textAlign: 'start'}}>
                  {t('name')}
                </span>
                <TextField
                  error={!!error.first_name}
                  label=''
                  value={data.first_name}
                  size="small"
                  onChange={handleChangeProfile}
                  name='first_name'
                  placeholder={t('name')}
                />
                {!!error.first_name &&
                  <Typography align='center' variant='caption' sx={{color: '#f42020'}}>
                    {error.first_name}
                  </Typography>
                }
              </InputWrapper>

              <InputWrapper>
                <span style={{textAlign: 'start'}}>
                {t('last_name')}
                </span>
                <TextField
                  error={!!error.last_name}
                  label=''
                  value={data.last_name}
                  size="small"
                  onChange={handleChangeProfile}
                  name="last_name"
                  placeholder={t('last_name')}
                />
                {!!error.last_name &&
                  <Typography align='center' variant='caption' sx={{color: '#f42020'}}>
                    {error.last_name}
                  </Typography>
                }
              </InputWrapper>

            </AccordionDetails>
            <AccordionActions>
              <Button onClick={cancelEditProfile}>کنسل</Button>
              <Button onClick={handleClick}>تایید</Button>
            </AccordionActions>
          </Accordion>
      </List>

      {/*<List>*/}
      {/*  <ListItem disablePadding>*/}
      {/*    <ListItemButton>*/}
      {/*      <ListItemIcon>*/}
      {/*        <LanguageIcon />*/}
      {/*      </ListItemIcon>*/}
      {/*        <Select*/}
      {/*         label="Language"*/}
      {/*         size={'small'}*/}
      {/*         onChange={handleChangeLang}*/}
      {/*         value={i18n.language}*/}
      {/*        >*/}
      {/*          <MenuItem value={'fa'}>فارسی</MenuItem>*/}
      {/*          <MenuItem value={'en'}>English</MenuItem>*/}
      {/*        </Select>*/}
      {/*    </ListItemButton>*/}
      {/*  </ListItem>*/}
      {/*</List>*/}

      {/* <Divider /> */}
      <List>
        <ListItem disablePadding>
          <ListItemButton onClick={logout}>
            <ListItemIcon>
              <LogoutIcon />
            </ListItemIcon>
            <ListItemText primary={t('exit')} />
          </ListItemButton>
        </ListItem>
      </List>
    </Box>
  );

  return (
    <Drawer open={open} onClose={toggleDrawer(false)}>
      {DrawerList}
    </Drawer>
  );
}
